<template>
  <label
    class="sc3-form-label sc3-form-label-inline sc3-form-label-small"
    :for="htmlId"
  >YEARS</label>
  <br />
  <select
    :id="htmlId"
    class="sc3-select-menu sc3-select-menu-inline sc3-select-menu-compact sc3-select-menu-white-and-grey"
    v-model="localRangeYears"
    @change="handleRangeYearsMenuChanged()"
  >
    <option
      v-for="rangeYearsOption in RANGE_YEARS_OPTIONS_ARRAY"
      :key="rangeYearsOption"
      :value="rangeYearsOption"
    >{{ rangeYearsOption }}</option>
  </select>
</template>

<script lang="ts" setup>
  import { ref, toRefs, watch } from 'vue';
  import { useAuthentication } from '@/composables/useAuthentication';
  import { useModals } from '@/composables/useModals';
  import {
    RANGE_YEARS_OPTIONS_ARRAY,
    isRangeYearsOptionAllowedForFreeUsers,
    isRangeYearsOptionAllowedForBasicMembers,
    isRangeYearsOptionAllowedForExtraMembers,
    RangeYearsOption
  } from '@/enums/range-years-options';

  const { isLoggedIn, isBasic, isExtra } = useAuthentication();
  const {
    launchCreateAccountModal,
    launchUpgradeToExtraModal,
    launchUpgradeToProModal
  } = useModals();
  const props = defineProps<{
    rangeYears: RangeYearsOption;
    htmlId: string;
  }>();
  const { rangeYears, htmlId } = toRefs(props);

  const emit = defineEmits<{
    (e: 'update:rangeYears', rangeYears: RangeYearsOption): void;
  }>();

  const localRangeYears = ref(rangeYears.value);

  function handleRangeYearsMenuChanged() {
    if (
      !isLoggedIn.value &&
      !isRangeYearsOptionAllowedForFreeUsers(localRangeYears.value)
    ) {
      syncLocalRangeYears();
      launchCreateAccountModal();
      return;
    }

    if (
      (!isLoggedIn.value || isBasic.value) &&
      !isRangeYearsOptionAllowedForBasicMembers(localRangeYears.value)
    ) {
      syncLocalRangeYears();
      launchUpgradeToExtraModal();
      return;
    }

    if (
      (!isLoggedIn.value || isBasic.value || isExtra.value) &&
      !isRangeYearsOptionAllowedForExtraMembers(localRangeYears.value)
    ) {
      syncLocalRangeYears();
      launchUpgradeToProModal();
      return;
    }

    emit('update:rangeYears', localRangeYears.value);
  }

  function syncLocalRangeYears() {
    localRangeYears.value = rangeYears.value;
  }

  watch(rangeYears, syncLocalRangeYears);
</script>
